import Vue from 'vue'
import Supplier from "Models/Supplier"
import Employee from "Models/Employee"
import Role from "Models/Role"
import Permission from "Models/Permission"
import Customer from "Models/Customer"

import County from "Models/StaticData/County"

import Vehicle from "Models/Vehicle"

import Workstation from "Models/Workstation"
import Account from "Models/Account"

import Expense from "Models/Expense"
import ExpenseItem from "Models/ExpenseItem"
import Payment from "Models/Payment"
import PaymentTransaction from "Models/PaymentTransaction"
import Contract from "Models/Contract"
import Invoice from "Models/Invoice"

import Appointment from "Models/Appointment"

class Api {
    constructor()
    {
        this.$http = window.axios
        Vue.prototype.$db = this

        this.County = County

        this.Supplier = Supplier
        this.Employee = Employee
        this.Customer = Customer
        this.Role = Role
        this.Permission = Permission
        this.Vehicle = Vehicle

        this.Workstation = Workstation

        this.Expense = Expense
        this.ExpenseItem = ExpenseItem
        this.Payment = Payment
        this.PaymentTransaction = PaymentTransaction
        this.Account = Account
        this.Contract = Contract
        this.Invoice = Invoice

        this.Appointment = Appointment
    }
}

export default new Api()
